<template>
  <div class="aisea-operation-report-list">
    <operation-report-list-page-layout-template
      v-if="isReportListConfigFetched"
      :initialSearchConditions="parsedSearchConditions"
    ></operation-report-list-page-layout-template>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { notifySystemError } from "@/utils/operations";
import isObject from "lodash/isObject";
const { mapActions } = createNamespacedHelpers("operations");
const { mapActions: mapActionsOperationReports } = createNamespacedHelpers(
  "operationReports"
);

import OperationReportListPageLayoutTemplate from "./page-layout-template/OperationReportListPageLayoutTemplate";
import operationReportService from "@/services/operations/operationReportService";

export default {
  name: "OperationReportList",
  components: {
    OperationReportListPageLayoutTemplate,
  },
  data() {
    return {
      isReportListConfigFetched: false,
      searchConditions: {},
    };
  },

  computed: {
    parsedSearchConditions() {
      if (!isObject(this.searchConditions)) return {};
      return operationReportService.getOriginalArgumentsFromRequestObject(
        this.searchConditions
      );
    },
  },

  methods: {
    ...mapActions(["setOperationCommonConfiguration"]),
    ...mapActionsOperationReports(["resetState"]),
    async setOperationReportConfiguration() {
      try {
        await Promise.all([
          this.setOperationCommonConfiguration(), // 一覧表示時はAPIから取得する共通設定を必ず取得
          operationReportService.getReportSearchConditions().then(res => {
            this.searchConditions = res; // 検索条件を取得
          }),
        ]);
        return true;
      } catch (_e) {
        notifySystemError(this);
        return false;
      }
    },
  },

  async created() {
    this.isReportListConfigFetched = await this.setOperationReportConfiguration();
  },

  beforeDestroy() {
    this.resetState(); // レポート一覧画面を離れるときにstoreのレポート一覧データをリセット
  },
};
</script>
